/* eslint-disable typescript-sort-keys/string-enum */

enum EmailSection {
  PiecesYouAreSelling = "Pieces you're selling",
  PiecesYouAreBiddingOn = "Pieces you're bidding on",
  PeopleYouFollow = "People you follow",
  Offers = "Offers",
  Other = "Other",
}

export default EmailSection;
